import React from 'react'
import flow from './assets/flowchart.png'
const tentime = () => {
    return (
        <div>
            <div className='container '>
                <h2>Write a pseudocode and flow chart to print Hello World 10 times.</h2> <br />
                <p><b>Explaination:-</b></p> <br />
                <p style={{marginLeft:50}}>We have to take a input as <b> Hello World </b> 
                and Print it 10 times</p> <br />
                <h3>Steps to create flow chart:-</h3>
                <ol >
                    <li>first start the programm</li>
                    <li>initalize the count by 0</li>
                    <li>Make a command to Print Hello world</li>
                    <li>Then add the increament to count by 1</li>
                    <li>Add the condition to count that till it reaches to 10 till print Hello world</li>
                    <li>After when Count reaches to 10 it will Stop</li>
                </ol>
            </div>
            <div className='container'>
            <img src={flow} alt="" />
            <h2>Steps to Write PseudoCode:-</h2>
            <ol>
                <li> Initialize a variable count by 0</li>
                
                <li>Then write a conditon that till count reaches to 10 print 'Hello world'</li>
            </ol>
            <p>
                count =0  <br />
                while (count ≤ 10) <br />
                   print hello world <br />
                   count &#5176;-- +1 <br />
                
            </p>
            </div>
        </div>
    )
}

export default tentime
